module.exports = __webpack_public_path__ + "img/logo.c1c1d773.png";